import { render, staticRenderFns } from "./HealthInsuranceCompanyInformationTab.vue?vue&type=template&id=45c6b3c2&"
import script from "./HealthInsuranceCompanyInformationTab.vue?vue&type=script&lang=js&"
export * from "./HealthInsuranceCompanyInformationTab.vue?vue&type=script&lang=js&"
import style0 from "./HealthInsuranceCompanyInformationTab.vue?vue&type=style&index=0&id=45c6b3c2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports